import * as i0 from '@angular/core';
import * as i1 from './modal.module';
import * as i2 from './modal-backdrop.component';
import * as i3 from './modal.directive';
import * as i4 from './modal-container.component';
export const ModalModuleNgFactory:i0.NgModuleFactory<i1.ModalModule> = (null as any);
var _decl0_0:i2.ModalBackdropComponent = (<any>(null as any));
var _decl0_1:i3.ModalDirective = (<any>(null as any));
var _decl0_2:i4.ModalContainerComponent = (<any>(null as any));
var _decl0_3:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_4:i0.ElementRef<any> = (<any>(null as any));
function _View_ModalBackdropComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ModalBackdropComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_ModalContainerComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
  const pd_1:any = ((<any>_decl0_2.onClick(_any)) !== false);
  const pd_2:any = ((<any>_decl0_2.onEsc(_any)) !== false);
}
function _View_ModalContainerComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = ('modal-dialog' + (_decl0_2.config.class? (' ' + _decl0_2.config.class): ''));
  currVal_0;
}
